<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Sayaç Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!Liste && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="Liste && !lo"
      row-key="id"
      :height="Height">
      <el-table-column
        prop="Tarih"
        label="Tarih"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="Kategori"
        label="Kategori">
      </el-table-column>
      <el-table-column
        prop="iEndeks"
        label="İlk Endeks"
        width="100">
      </el-table-column>
      <el-table-column
        prop="sEndeks"
        label="Son Endeks"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Tuketim"
        label="Tüketim"
        width="80">
      </el-table-column>
      <el-table-column
        prop="Tutar"
        label="Tutar"
        align="right"
        width="70">
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
import Yukleniyor from "../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Kisi_id"],
  data() {
    return {
      lo: true,
      Liste: null,
      Height: window.innerHeight - 215
    }
  },
  methods: {

    SayfaYukle() {
      if (this.Kisi_id) {
        this.$store.dispatch("Get", {path: 'yonetim/kisi/ekran/' + this.Kisi_id + '/sayac'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      }


    },

  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiSayac.vue